import { pushDataLayer } from './tagManagerConsent';

const fireUpsellEvent = (productDetails: any) => {
  const tagManagerArgs: any = {
    dataLayer: {
      event: 'eec.add',
      ecommerce: {
        add: {
          actionField: {
            list: 'PRODUCT PAGE',
          },
        },
        products: productDetails,
      },
    },
  };
  pushDataLayer(tagManagerArgs);
};

export default fireUpsellEvent;